import React from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

function ResponsiblePartyInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Responsible Party Information</span>
        </div>
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyTitle)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartyTitle)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartyTitle]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyFirstName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartyFirstName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartyFirstName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyMiddleName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartyMiddleName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartyMiddleName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartyLastName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartyLastName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartyLastName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartySuffixName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartySuffixName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartySuffixName]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.responsiblePartySSN)}
          label={(
            <>
              Social Security Number&nbsp;
              <OverlayTrigger
                placement="top"
                delay={{ show: 0, hide: 0 }}
                trigger={["hover", "click"]}
                overlay={(
                  <Tooltip id={`tooltip-${FORM_FIELD_KEYS.responsiblePartySSN}-subhint`} className="subhintTooltipFederal">
                    <span>
                      In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                      This information is secured with SSL encryption.
                    </span>
                  </Tooltip>
                )}
              >
                <a className="ssn-subhint-title">
                  Why is this needed?
                </a>
              </OverlayTrigger>
            </>
          )}
          placeholder={getFieldProps(FORM_FIELD_KEYS.responsiblePartySSN)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.responsiblePartySSN]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default ResponsiblePartyInfoBlock;
